export default __webpack_public_path__ + "static/media/learntech.ccc9e6c0.svg";